<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select by Donation cause</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="dcs_FilterLabel"
                    name="dcs_FilterLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="dcs_FilterLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in donationLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Search by Donation ID</span>
                </div>
                <div class="col-md-6 header-middle">
                  <masked-input
                    type="text"
                    name="dcs_FilterCode"
                    class="form-control"
                    :mask="[
                      /[A-Z]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i
                    ]"
                    :guide="false"
                    :showMask="false"
                    :pipe="toUpperCase"
                    v-model.trim="dcs_FilterCode"
                    spellcheck="false"
                  >
                  </masked-input>
                </div>
                <div class="col-md-2 cmi-search-header-btn-search">
                  <button
                    @click="getFormDataByCode"
                    v-bind:disabled="disableCriteriaMet_dcs_FilterCode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new item
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Donation causes</h3>
        </div>

        <div class="panel-body">
          <div v-if="showDonationCode" class="form-group">
            <label for="dcs_DonationCode">Donation cause ID</label>
            <div
              id="dcs_DonationCode"
              name="dcs_DonationCode"
              class="form-control cmi-file-label"
            >
              {{ fdata.dcs_DonationCode }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('dcs_DonationCause') }"
          >
            <label for="dcs_DonationCause">Donation cause</label>
            <input
              id="dcs_DonationCause"
              name="dcs_DonationCause"
              v-model.trim="fdata.dcs_DonationCause"
              v-validate.initial="{ required: true, max: 100 }"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("dcs_DonationCause")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('dcs_DonationMoreInfo') }"
          >
            <label for="dcs_DonationMoreInfo">Additional information</label>
            <textarea
              id="dcs_DonationMoreInfo"
              name="dcs_DonationMoreInfo"
              v-model.trim="fdata.dcs_DonationMoreInfo"
              v-validate.initial="{ required: true, max: 2000 }"
              maxlength="2000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("dcs_DonationMoreInfo")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('dcs_Status') }"
          >
            <label for="dcs_Status">Status</label>
            <select
              id="dcs_Status"
              name="dcs_Status"
              v-model="fdata.dcs_Status"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("dcs_Status") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-donationcauses"
        :width="350"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span>Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            v-on:click="saveFormData"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  // components: {
  //   VueRecaptcha,
  // },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        dcs_DonationCode: "",
        dcs_DonationCause: "",
        dcs_DonationMoreInfo: "",
        dcs_Status: 1
      },
      showAnimation: false,
      alertMessage: "",
      donationLabels: [],
      dcs_FilterLabel: "",
      dcs_FilterCode: "",
      aniLabelsLoading: false
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-donationcauses");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-donationcauses");
        return;
      }

      if (!this.fdata.pkey) {
        this.resetFormData();
      }

      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-donationcauses");
      await this.getDonationLabels();
      this.showAnimation = false;
    },
    getFormDataByLabel: async function() {
      this.dcs_FilterCode = "";
      if (!this.dcs_FilterLabel) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;

      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.dcs_FilterLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        this.aniLabelsLoading = false;
        return;
      }

      this.aniLabelsLoading = false;
      this.resetFormData();
      this.alertMessage = "Item not found";
      this.$modal.show("alert-dialog-donationcauses");
    },
    getFormDataByCode: async function() {
      this.dcs_FilterLabel = "";
      const dcs_FilterCode = this.dcs_FilterCode.replace(/\s/g, "");
      if (!dcs_FilterCode) {
        this.resetFormData();
        return;
      }

      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pcode: dcs_FilterCode }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByCode`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        this.aniLabelsLoading = false;
        return;
      }

      this.aniLabelsLoading = false;
      this.resetFormData();
      this.alertMessage = "Item not found";
      this.$modal.show("alert-dialog-donationcauses");
    },
    getDonationLabels: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetDonationLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.donationLabels, rData);
      }
      this.aniLabelsLoading = false;
    },

    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-donationcauses");
    },
    newFormData: function() {
      this.resetFormData();
      this.dcs_FilterLabel = "";
      this.dcs_FilterCode = "";
    },
    toUpperCase(value) {
      return value.toUpperCase();
    },
    resetFormData() {
      Object.assign(this.fdata, {
        pkey: 0,
        dcs_DonationCode: "",
        dcs_DonationCause: "",
        dcs_DonationMoreInfo: "",
        dcs_Status: 1
      });
    }
  },
  computed: {
    showDonationCode: function() {
      if (this.fdata.dcs_DonationCode) {
        return true;
      }
      return false;
    },
    disableCriteriaMet_dcs_FilterCode: function() {
      if (this.dcs_FilterCode && this.dcs_FilterCode.length == 16) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getDonationLabels();
  }
};
</script>
